export enum WishListActionTypes{
    ADD_PRODUCT_TO_WISHLIST='ADD_PRODUCT_TO_WISHLIST',
    DELETE_ITEM_FROM_WISHLIST='DELETE_ITEM_FROM_STORE'
}